import { useContext, useMemo } from "react";
import PageContext from "../../Context/Display/Pages/PagesContext";
import { getPageFromPages, getPagesOfPortal } from "../../Components/Display/utils";
import { UPDATE_PAGE_COMPONENT, UPDATE_PAGE_PROPERTIES } from "../../Context/Display/Pages/PagesContextEvents";

function usePages() {
    const { state, dispatch } = useContext(PageContext);

    return [state, dispatch];
}

export function useSelectedPage() {
    const [state] = usePages();
    const { selectedPageIndex } = state;

    const selectedPage = useMemo(
        () => {
            return getPageFromPages(state.pages, selectedPageIndex)
        }, [state.pages, selectedPageIndex]
    );

    return selectedPage;
}

export function usePortalPages() {
    const [{ pages }] = usePages();
    const selectedPage = useSelectedPage();
    
    const portalPages = useMemo(() => {
        return getPagesOfPortal(selectedPage.portalId, pages);
    }, [pages, selectedPage]);

    return portalPages;
}

export function useUpdatePageProperties() {
    const [, dispatch] = usePages();

    function updatePage(parentId, pageId, properties) {
        dispatch({
            type: UPDATE_PAGE_PROPERTIES,
            payload: {
                parentId,
                pageId,
                properties
            }
        })
    }

    return updatePage;
}

export function useUpdatePageComponent(folderId, pageId) {
    const [, dispatch] = usePages();

    function updatePageComponent(componentId, properties) {
        dispatch({
            type: UPDATE_PAGE_COMPONENT,
            payload: {
                parentId: folderId,
                pageId,
                componentId,
                properties
            }
        })
    }

    return updatePageComponent;
}

export default usePages;